import React from 'react';
import propTypes from 'prop-types';
import Styles from './Homepage.module.scss';

const Homepage = ({ children }) => {
  return (
    <div className={Styles['homepage-wrapper']}>
      <p className={Styles['section-title']}>Home</p>
      <div className={Styles['content-box']}>
        <div className={Styles['content']}>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

Homepage.propTypes = {
  children: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string
  ])
};

export default Homepage;
